import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import Seo from '../components/Seo';
import { useLang } from '../context/LanguageContext';
import useReveal from '../hooks/useReveal';
import { PageHero } from './Services';
import { IMAGES } from '../mock/mock';

const FAQ = () => {
  const { t, lang } = useLang();
  useReveal(lang);
  const items = t('faq.items');
  const faqJsonLd = {
    '@context': 'https://schema.org', '@type': 'FAQPage',
    mainEntity: (items || []).map((f) => ({
      '@type': 'Question', name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <div>
      <Seo title="FAQ — OEM & Private Label Cosmetics Manufacturing" path="/faq"
        description="Answers on MOQs, custom formulation, packaging, GMP/ISO 22716 certification and global export for OEM, private-label and contract luxury cosmetics manufacturing (produced in Türkiye)."
        jsonLd={faqJsonLd} />
      <PageHero kicker={t('faq.kicker')} title={t('faq.title')} subtitle={t('faq.subtitle')} image={IMAGES.bottlesNeutral} />
      <section className="py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 reveal">
          <Accordion type="single" collapsible className="space-y-4">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-gold-soft bg-cream px-6 data-[state=open]:bg-ivory data-[state=open]:border-gold transition-colors">
                <AccordionTrigger className="text-left rtl:text-right font-serif text-xl text-espresso hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-mocha leading-relaxed text-[0.95rem] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <section className="py-20 bg-cream text-center">
        <div className="max-w-2xl mx-auto px-6 reveal">
          <h2 className="font-serif text-3xl md:text-4xl text-espresso">{t('contact.title')}</h2>
          <p className="mt-4 text-mocha">{t('contact.subtitle')}</p>
          <Link to="/contact" className="group mt-8 inline-flex items-center gap-3 px-10 py-4 bg-espresso text-ivory text-xs tracking-[0.2em] uppercase hover:bg-gold transition-colors">
            {t('home.ctaButton')}<ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform rtl:rotate-180" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
